<li *ngFor="let i of actions; let last = last">
  <ng-template [ngTemplateOutlet]="i"></ng-template>
  <em *ngIf="!last" class="ant-list-item-action-split"></em>
</li>
